/**
 * 指定されたミリ秒だけ待機する
 * @param ms - 待機するミリ秒
 */
export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms))
